import styled from"../../styled-components";export const RedocComponentWrap=styled.div`
  margin: 20px 0;
  box-shadow: 0px 10px 30px 0px rgba(35, 35, 35, 0.34);
`;export const OpenApiExampleWrap=styled(RedocComponentWrap)`
  button {
    color: #fff;
  }
`;